import { useLingui } from "@lingui/react/macro";
import type { ModalVariant } from "@offstreetparking/design-system/overlay";
import { Text } from "@offstreetparking/design-system/typography";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import { Drawer } from "../Drawer";
import { FlowModal as Modal } from "../FlowModal/FlowModal";
import { FlowDialogTitle } from "../FlowModal/FlowModalTitle";
type ResponsiveOverlayProps = {
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
	onAnimationComplete?: () => void;
	title: React.ReactNode | string;
	description?: string;
	variant?: ModalVariant;
	children: React.ReactNode;
};
export const ResponsiveOverlay = ({
	isOpen,
	onOpenChange,
	onAnimationComplete,
	title,
	description,
	variant,
	children,
}: ResponsiveOverlayProps) => {
	const { t } = useLingui();
	const isDesktop = useIsDesktop();
	if (variant || isDesktop) {
		return (
			<Modal
				isOpen={isOpen}
				onClose={() => onOpenChange(false)}
				onAnimationComplete={onAnimationComplete}
				size="md"
				variant={variant}
				i18n={{
					closeButton: t`Close`,
					cancelButton: t`Cancel`,
				}}
			>
				<FlowDialogTitle className="font-bold text-lg text-neutral leading-6">{title}</FlowDialogTitle>
				{description && (
					<Text intent="muted" className="mt-2" size="sm">
						{description}
					</Text>
				)}
				<div className="mt-4">{children}</div>
			</Modal>
		);
	}
	return (
		<Drawer
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			onAnimationComplete={onAnimationComplete}
			title={title}
			description={description}
		>
			{children}
		</Drawer>
	);
};
